module.exports = __webpack_public_path__ + "img/thomas.2a7c13a6.jpg";